import Image from "@namia/image";
import React from "react";

const HcGrid = ({ grid, headline }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-grid wp-block-kehittamo-block-hc">
      <div className="">
        <div className="flex flex-col gap-8 xl:flex-row">
          <h2 className="m-0 mb-2 p-0 text-xl font-bold xl:w-1/3 xl:text-left xl:text-4xl hidden xl:block">
            {headline}
          </h2>
          <div className="flex flex-col items-center gap-8 xl:grid xl:grid-cols-2 xl:grid-rows-2">
            <h2 className="m-0 mb-2 p-0 text-xl font-bold xl:w-1/3 xl:text-left xl:text-4xl xl:hidden">
              {headline}
            </h2>
            {grid.map(({ image, headline, body }, index) => {
              return (
                <div key={index} className="flex flex-col gap-4">
                  <div className="w-24 h-24 max-w-24 max-h-24 relative flex flex-col justify-end">
                    <Image
                      className=""
                      alt="alt"
                      base64={image.base64}
                      onError={() => {}}
                      placeholder={image.placeholder}
                      onLoad={() => {}}
                      placeholderBase64={image.placeholderBase64}
                      ratio={image.width / image.height}
                      src={image.src}
                      srcset={image.srcset}
                    />
                  </div>
                  <h3 className="m-0 max-w-96 p-0 text-lg font-semibold uppercase xl:text-2xl">
                    {headline}
                  </h3>
                  <p className="m-0 max-w-96 p-0 text-base font-semibold xl:lg">
                    {body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HcGrid;
